import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { Provider } from './AnalyticsContext';
import Analytics from '../../utils/analytics';
import User from '../../models/User';

export class AnalyticsProvider extends React.Component {
    static propTypes = {
        children: PropTypes.element,
        user: PropTypes.instanceOf(User)
    };

    constructor(props) {
        super(props);
        if (!window.analytics) {
            window.analytics = new Analytics(props.user);
        }
    }

    componentDidUpdate() {
        if (window.analytics && this.props.user) {
            window.analytics.setUser(this.props.user);
        }
    }

    render() {
        return <Provider value={window.analytics}>{this.props.children}</Provider>;
    }
}

const mapStateToProps = (state) => ({
    user: state.user
});

export default connect(mapStateToProps)(AnalyticsProvider);
